// extracted by mini-css-extract-plugin
module.exports = {"column":"style_column__1LiWI","cell":"style_cell__2YYpd","cols":"style_cols__3SuYV","col":"style_col__3gVdb","name":"style_name__2pcxe"};